import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";

import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState, useContext } from "react";
import ApiService from "../../services/app.service";
import InnerHeader from "../Layout/InnerHeader";
import ImageUpload from "./ImageUpload";
import Output from "./Output";
import { SnackbarContext } from "../../App";

export default function Chart() {
  const [file1, setFile1] = useState(null);
  const [outPut, setOutPut] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setSnack } = useContext(SnackbarContext);

  const handleSubmit = async () => {
    setLoading(true);
    const data = {
      image: file1[0],
      chartType: "piechart",
    };
    try {
      const response = await ApiService.ChartDataAnalyzor(data);
      setOutPut(response.data);
    } catch (e) {
      setSnack({
        message: e?.response?.data?.message ?? e.message,
        open: true,
        colour: "error",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!file1) {
      setOutPut([]);
    }
  }, file1);

  return (
    <Box className="imageComparison">
      <InnerHeader name={"Chart Validation"} />
      <Box className="imageComparison">
        <Box>
          <Grid container alignItems="center" spacing={1}>
            <Grid size={5}>
              <Box className="imgUpMain">
                <Box className="imgDisplay">
                  {file1 && file1[0] && (
                    <Box className="imgBox">
                      <img src={file1[0] ? URL.createObjectURL(file1[0]) : ""} alt="" />
                    </Box>
                  )}
                </Box>
                <ImageUpload setFile={setFile1} file={file1} />
              </Box>
            </Grid>
            <Grid size={2}>
              <Box mt="16px" textAlign="center">
                <Button disabled={loading || !file1} variant="contained" size="small" onClick={handleSubmit}>
                  {loading ? (
                    <>
                      <CircularProgress
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#ffffff",
                          marginRight: "8px",
                        }}
                      />
                      Analyze
                    </>
                  ) : (
                    <>Analyze</>
                  )}
                </Button>
              </Box>
            </Grid>
            <Grid size={5}>
              {outPut?.Data && (
                <Box>
                  <Output outPut={outPut} />
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
